import { Schema, ValidationError, Validator } from '../jsonschema/lib';
import { IJSONSchema } from '../IJSONSchema';
import IValidationError from '../IValidationError';
import ValidationFrameworkAdapter from '../IValidationFrameworkAdapter';

class JsonschemaFrameworkAdapter implements ValidationFrameworkAdapter {
  removeDuplicates(myArr: any[], prop: string) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }
  validate(schema: IJSONSchema, object: any): IValidationError[] {
    const v = new Validator();
    const { errors } = v.validate(object, schema as Schema);
    const filterValidations = [
      'allOf',
      'anyOf',
      'oneOf',
      'not',
      'if',
      'then',
      'else',
    ];

    return this.removeDuplicates(errors, 'stack')
      .map((error) => this.frameworkErrorToGlittrError(schema, error))
      .filter((error) => !filterValidations.includes(error.keyword));
  }
  frameworkErrorToGlittrError(schema: IJSONSchema, frameworkError: ValidationError): IValidationError {
    const keyword = frameworkError.name;
    const params = { [frameworkError.name]: frameworkError.argument };
    let path = frameworkError.property.split('.');
    let propName;
    if (path.length > 0) {
      propName = path[path.length - 1] as string;
    }
    // remove first entry 'instance'
    path.shift();
    if (frameworkError.name.toLowerCase() === 'required') {
      propName = frameworkError.argument ?? propName;
      path = frameworkError.argument ? [...path, frameworkError.argument] : path;
    }
    const mappedError = {
      params,
      keyword,
      path,
      propName,
      message: '',
      label: undefined,
      description: undefined,
    };
    return mappedError;
  }
}

export default new JsonschemaFrameworkAdapter();
